import { useTranslation } from 'react-i18next';

import { formatDateDisplay } from '@/utils/date';

interface ActiveFishGroupCellProps {
    fishGroup: { name: string; fromDate: string } | null | undefined;
}

/**
 * The fish group in a pen now, with the start of its stay on hover. An empty pen
 * reads as a dash, like every other blank cell in the internal tables.
 */
export default function ActiveFishGroupCell(props: ActiveFishGroupCellProps) {
    const { fishGroup } = props;
    const { t } = useTranslation('fishGroups');

    if (!fishGroup) {
        return <>-</>;
    }

    return (
        <span
            // `fromDate` is the instant the stay began (timestamptz), not a stored calendar
            // day, so it is shown as the viewer's day of that instant.
            title={t('locationOverview.sinceValue', {
                date: formatDateDisplay(fishGroup.fromDate),
            })}>
            {fishGroup.name}
        </span>
    );
}
